// extracted by mini-css-extract-plugin
export default {"container":"WaitingPage_container__BoCmS","titleText":"WaitingPage_titleText__rIpnE","mainText":"WaitingPage_mainText__lImUX"};